import request from "src/utils/request";
import useApi from "src/utils/api/use-api";
import { sleep } from "src/utils/api/mock-utils";

const useSubscriptionApi = () => {
    const getMockData = async () => {
        await sleep();
        return [
            {
                subscription: {
                    status: "active",
                    trialStart: 1639574650,
                    trialEnd: 1640179450,
                    currentPeriodStart: 1640179450,
                    currentPeriodEnd: 1643070314,
                    cancelAtPeriodEnd: false,
                    name: "Pro Plan",
                    price: "1000",
                },
                paymentMethod: {
                    billingDetails: {
                        address: {
                            city: "Paris",
                            country: "FR",
                            line1: "3 rue des something",
                            line2: null,
                            postal_code: "75001",
                            state: null,
                        },
                        email: "jason@adadot.com",
                        name: "some",
                        phone: null,
                    },
                    card: {
                        brand: "visa",
                        checks: {
                            address_line1_check: "pass",
                            address_postal_code_check: "pass",
                            cvc_check: "pass",
                        },
                        country: "US",
                        exp_month: 12,
                        exp_year: 2025,
                        funding: "credit",
                        last4: "4242",
                    },
                },
            },
        ];
    };
    if (process.env.MOCK_SUBSCRIPTION === "true") return useApi(() => getMockData());
    return useApi(() => request("/api/payments/subscriptions"));
};

export default useSubscriptionApi;
